import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';

import { useAuth } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom'

const HeaderMobile = () => {

    const navigate = useNavigate()
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }  = useAuth()
    const lobinAuthority = authInfo.authority
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const hancleClick = (menu) => {
    navigate(menu)
  }

  return (
    <div style={{ position: 'fixed', left: 0, top: 0, width: '100%', color: 'white', textAlign: 'center', backgroundColor : '#fff' }}>
      
    <AppBar position="static">
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MenuIcon />
          <div style={{marginLeft:'1rem'}}>
          SmartG-Expert
          </div>
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={() => hancleClick('/homeMobile')}>ホーム</MenuItem>
          <MenuItem onClick={() => hancleClick('/bidGroupMobile')}>本日の入札情報</MenuItem>
          <MenuItem onClick={() => hancleClick('/mobile')}>ログアウト</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
    </div>
  );
};

export default HeaderMobile;